<ion-content>
  <ion-grid>
    <ion-row class="ion-padding ion-justify-content-center">
      <ion-col size="12" size-md="10" size-lg="8" size-xl="6">
        <div id="log-in-card">
          <img src="https://axwcmrbv16f0.objectstorage.sa-santiago-1.oci.customer-oci.com/n/axwcmrbv16f0/b/monitorsur-prd/o/public-assets%2Flogo_ma_nov23.png" 
            alt="Monitor Austral" (click)="goHome()" title="¿Qué es Monitor Austral?">

            <h5>Seguimiento y transparencia de licitaciones en un solo lugar</h5>

          <firebase-ui
            [language]="'es_419'"
            (signInSuccessWithAuthResult)="onFirebaseUiSuccess($event)"
            (signInFailure)="onFirebaseUiError($event)"
          ></firebase-ui>

          <p class="notes">*La creación de cuentas es automática</p>

        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
